import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { http } from "../client";

// DTR cut-off schedule per company (company-setup, COMPANY scope).
// GET → { companyId, source: OWN|INHERITED|GLOBAL|DEFAULT, inheritedFrom, current: Rule,
//   upcoming: Rule[], own: Rule[], preview: [Period + { weeks }] × 6, rules: text }
// Rule = { frequency, firstStartDay, secondStartDay, startDay, weekStartsOn (1 Mon…7 Sun),
//   effectiveFrom, weekStartsOnName, description }
const data = (r) => r.data;
export const cutoffSettingsApi = {
  get: (companyId) =>
    http
      .get("/dtr/cutoff-settings", {
        params: companyId ? { companyId } : {},
      })
      .then(data),
  // Adds a rule (or replaces the one with the same effectiveFrom); companyId may be "global"
  save: (companyId, rule) =>
    http.put(`/dtr/cutoff-settings/${companyId}`, rule).then(data),
  // Removes upcoming rules: one (effectiveFrom) or all
  remove: (companyId, effectiveFrom) =>
    http
      .delete(`/dtr/cutoff-settings/${companyId}`, {
        params: effectiveFrom ? { effectiveFrom } : {},
      })
      .then(data),
};

export const useCutoffSettings = (companyId, { enabled = true } = {}) =>
  useQuery({
    queryKey: ["cutoffSettings", companyId || "mine"],
    queryFn: () => cutoffSettingsApi.get(companyId),
    enabled,
  });

// Cut-offs and weeks follow the schedule: refresh every DTR view
const useScheduleMutation = (fn) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: fn,
    onSuccess: () =>
      [["cutoffSettings"], ["dtr"], ["me:dtr"]].forEach((queryKey) =>
        qc.invalidateQueries({ queryKey }),
      ),
  });
};
export const useSaveCutoffRule = () =>
  useScheduleMutation(({ companyId, rule }) =>
    cutoffSettingsApi.save(companyId, rule),
  );
export const useRemoveCutoffRule = () =>
  useScheduleMutation(({ companyId, effectiveFrom }) =>
    cutoffSettingsApi.remove(companyId, effectiveFrom),
  );
